import { NgModule } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterModule, Routes } from '@angular/router';
import { DocumentPageComponent } from './adhoc/document-page/document-page.component';
import { FaqComponent } from './adhoc/faq/faq.component';
import { GenericErrorComponent } from './adhoc/generic-error/generic-error.component';
import { setupWizard } from './admin/pages/setup-wizard/setup-wizard.guard';
import { hasPermissions } from './auth/permissions/permissions.guard';
import { hasAccountAccess } from './auth/utility/account.guard';
import { isAuthenticated, isZevaRep } from './auth/utility/auth.guard';
import { ipGuard } from './auth/utility/ip.guard';
import { resolveAccount } from './auth/utility/resolvers/account.resolver';
import { resolvePermissions } from './auth/utility/resolvers/permissions.resolver';
import { BrandOnlyGuard } from './brand/brand.guard';
import { ZevaPageSelector } from './core/core.models';
import { ZEVA_PAGE_VIEW_PERMISSION, ZEVA_SUBSYSTEMS } from './core/core.static';
import { HomeComponent } from './core/home/home.component';
import { guardSequence } from './shared/helpers/utility';
import { subscriptionGuard } from './shared/subscription/subscription.guard';
import { resolveVehicles } from './shared/vehicle/vehicle-list.resolver';

const appRoutes: Routes = [
  {
    path: '',
    component: HomeComponent,
    resolve: {
      client: resolveAccount,
      permissions: resolvePermissions,
      vehicles: resolveVehicles,
    },
    canActivate: [guardSequence([ipGuard, isAuthenticated, hasAccountAccess, subscriptionGuard])],
    children: [
      { path: '', pathMatch: 'full', redirectTo: ZEVA_SUBSYSTEMS.monitoring.slug },
      {
        path: ZEVA_SUBSYSTEMS.insights.slug,
        canActivate: [
          hasPermissions(ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.INSIGHTS]),
          setupWizard,
        ],
        loadChildren: () => import('./insights/insights.module').then(m => m.InsightsModule),
        data: { title: ZEVA_SUBSYSTEMS.insights.name },
      },
      {
        path: ZEVA_SUBSYSTEMS.analytics.slug,
        canActivate: [
          hasPermissions(ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ANALYTICS_VEHICLE]),
          setupWizard,
        ],
        loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule),
        data: { title: ZEVA_SUBSYSTEMS.analytics.name },
      },
      {
        path: ZEVA_SUBSYSTEMS.monitoring.slug,
        canActivate: [setupWizard],
        loadChildren: () => import('./monitoring/monitoring.module').then(m => m.MonitoringModule),
        data: { title: ZEVA_SUBSYSTEMS.monitoring.name },
      },
      {
        path: ZEVA_SUBSYSTEMS.maintenance.slug,
        canActivate: [
          hasPermissions(ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.MAINTENANCE_LIST]),
          setupWizard,
        ],
        loadChildren: () =>
          import('./maintenance/maintenance.module').then(m => m.MaintenanceModule),
        data: { title: ZEVA_SUBSYSTEMS.maintenance.name },
      },
      {
        path: ZEVA_SUBSYSTEMS.admin.slug,
        canActivate: [],
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        data: { title: ZEVA_SUBSYSTEMS.admin.name },
      },
      {
        path: 'faq',
        canActivate: [],
        loadChildren: () => import('./adhoc/faq/faq.module').then(m => m.FaqModule),
        component: FaqComponent,
        data: { title: 'FAQ' },
      },
    ],
  },
  {
    path: 'auth',
    canActivate: [ipGuard],
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  { path: 'invite', redirectTo: 'auth/invite' },
  {
    path: 'privacy-policy',
    pathMatch: 'full',
    // canActivate: [ipGuard],
    loadChildren: () =>
      import('./adhoc/document-page/document-page.module').then(m => m.DocumentPageModule),
    data: { title: 'Privacy Policy' },
    component: DocumentPageComponent,
  },
  {
    path: 'terms-of-use',
    pathMatch: 'full',
    // canActivate: [ipGuard],
    loadChildren: () =>
      import('./adhoc/document-page/document-page.module').then(m => m.DocumentPageModule),
    data: { title: 'Terms of Use' },
    component: DocumentPageComponent,
  },
  {
    path: 'terms-of-service',
    pathMatch: 'full',
    // canActivate: [ipGuard],
    loadChildren: () =>
      import('./adhoc/document-page/document-page.module').then(m => m.DocumentPageModule),
    data: { title: 'Terms of Services' },
    component: DocumentPageComponent,
  },
  {
    path: 'internal',
    canActivate: [isZevaRep, ipGuard],
    loadChildren: () => import('./internal/internal.module').then(m => m.InternalModule),
  },
  {
    path: 'hail',
    canMatch: [BrandOnlyGuard],
    data: { brandOnly: 'hail' },
    loadChildren: () => import('./hail/hail.module').then(m => m.HailModule),
  },
  {
    path: 'error/:code',
    canActivate: [ipGuard],
    component: GenericErrorComponent,
  },
  { path: 'hail', loadChildren: () => import('./hail/hail.module').then(m => m.HailModule) },
  {
    path: '**',
    component: GenericErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: false, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [MatSnackBar],
})
export class AppRoutingModule {}
